import {
  BrowserCacheLocation,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import { MSAL_CONFIG, environments, getMsalEntraConfig } from './msal-config';

import { CommonUtility } from '../utils/commonUtils';
import { Auth0TokenService } from '../services/auth0-service/auth0-service';

/**
 *
 * @param auth0TokenService
 */
export function MSALInstanceFactory(
  auth0TokenService: Auth0TokenService,
): IPublicClientApplication {
  const env: string =
    environments.get(
      CommonUtility.getWindowLocationProperty('hostname').split('.')[0],
    ) || 'upsdev';
  const isV2Login: boolean = auth0TokenService.appConfig().v2Login;
  const config = isV2Login ? getMsalEntraConfig() : MSAL_CONFIG[env];
  return new PublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: config.authorityUrl,
      redirectUri: config.redirectUri,
      knownAuthorities: config.authorityDomain,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
  });
}
